'use client';
import React from 'react';
import { useState, useEffect } from 'react';

import {
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    LinkedinIcon,
    TwitterShareButton,
    XIcon,
    EmailShareButton,
    EmailIcon,
  } from "react-share";


// This does this isMounted check to get around a hydration issue.
function ShareSection() {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return null;
    }

    if(typeof window === 'undefined') return null;
    const shareUrl = window.location.href;

    return (
        <div className="social-section">
            <FacebookShareButton url={shareUrl} htmlTitle="Share on Facebook">
                <FacebookIcon size={32} round bgStyle={{fill: 'transparent'}} iconFillColor={'#0063a3'} />
            </FacebookShareButton>
            <TwitterShareButton url={shareUrl} htmlTitle="Share on X">
                <XIcon size={32} round bgStyle={{fill: 'transparent'}} iconFillColor={'#0063a3'} />
            </TwitterShareButton>
            <LinkedinShareButton url={shareUrl} htmlTitle="Share on LinkedIn">
                <LinkedinIcon size={32} round bgStyle={{fill: 'transparent'}} iconFillColor={'#0063a3'} />
            </LinkedinShareButton>
            {/* <EmailShareButton url={shareUrl} htmlTitle="Email this page">
                <EmailIcon size={32} round bgStyle={{fill: 'transparent'}} iconFillColor={'#0063a3'} />
            </EmailShareButton> */}
        </div>
    );
};

export default ShareSection;